/**
 * Preview document dialog data model
 */
export interface DocumentViewerDialogData {
  fileURL: string;
  fileExtension: string;
}

export enum FileExtension {
  PDF='pdf',
  PNG='png',
  JPG='jpg',
  JPEG='jpeg',
  GIF='gif',
  BMP='bmp',
  DOC='doc',
  DOCX='docx'
}
